import React from 'react'
import { Document, Page, Text, View } from '@react-pdf/renderer'

const statusColor = (met) => {
  if (met === null || met === undefined) return '#64748b'
  return met ? '#059669' : '#e11d48'
}

const Row = ({ label, value, target, met, striped }) => (
  <View
    style={{
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 4,
      paddingHorizontal: 6,
      backgroundColor: striped ? '#F5F7FA' : undefined,
    }}
    wrap={false}
  >
    <Text style={{ fontSize: 9, flex: 5 }}>{label}</Text>
    <Text style={{ fontSize: 9, flex: 2, textAlign: 'right' }}>{value}</Text>
    <Text style={{ fontSize: 9, flex: 2, textAlign: 'right', color: '#64748b' }}>
      {target ?? ''}
    </Text>
    <Text style={{ fontSize: 9, flex: 2, textAlign: 'right', color: statusColor(met) }}>
      {met === undefined || met === null ? '' : met ? 'Met' : 'Missed'}
    </Text>
  </View>
)

const PTSPerformancePDF = ({ orgName, rangeLabel, summary, printedBy }) => {
  const sla = summary?.slaComparison || {}
  const pct = (value) => (value === null || value === undefined ? '—' : `${value}%`)

  return (
    <Document>
      <Page size="A4" style={{ padding: 32, fontFamily: 'Helvetica' }}>
        <Text style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>
          PTS Performance Pack
        </Text>
        <Text style={{ fontSize: 11, color: '#334155', marginBottom: 2 }}>{orgName}</Text>
        <Text style={{ fontSize: 9, color: '#64748b', marginBottom: 12 }}>{rangeLabel}</Text>

        <View
          style={{
            flexDirection: 'row',
            paddingHorizontal: 6,
            paddingBottom: 4,
            borderBottom: '1px solid #CBD5E1',
          }}
        >
          <Text style={{ fontSize: 8, flex: 5, color: '#64748b' }}>Metric</Text>
          <Text style={{ fontSize: 8, flex: 2, textAlign: 'right', color: '#64748b' }}>
            Actual
          </Text>
          <Text style={{ fontSize: 8, flex: 2, textAlign: 'right', color: '#64748b' }}>
            Target
          </Text>
          <Text style={{ fontSize: 8, flex: 2, textAlign: 'right', color: '#64748b' }}>
            Status
          </Text>
        </View>

        <Row
          label="On-time pickup"
          value={pct(summary?.pickupKPI?.pct)}
          target={sla.onTimePickup ? `≥ ${sla.onTimePickup.target}%` : null}
          met={sla.onTimePickup?.met}
        />
        <Row
          label="On-time arrival"
          value={pct(summary?.arrivalKPI?.pct)}
          target={sla.onTimeArrival ? `≥ ${sla.onTimeArrival.target}%` : null}
          met={sla.onTimeArrival?.met}
          striped
        />
        <Row
          label="Aborted journeys"
          value={`${summary?.aborted ?? 0} (${pct(
            summary?.totalJourneys
              ? Math.round(((summary.aborted || 0) / summary.totalJourneys) * 100)
              : null,
          )})`}
          target={sla.aborted ? `≤ ${sla.aborted.target}%` : null}
          met={sla.aborted?.met}
        />
        <Row
          label="No-show journeys"
          value={`${summary?.noShow ?? 0} (${pct(
            summary?.totalJourneys
              ? Math.round(((summary.noShow || 0) / summary.totalJourneys) * 100)
              : null,
          )})`}
          target={sla.noShow ? `≤ ${sla.noShow.target}%` : null}
          met={sla.noShow?.met}
          striped
        />
        <Row
          label="Portal-booking share"
          value={pct(summary?.portalBookingSharePct)}
          target={null}
          met={null}
        />
        <Row
          label="Total journeys"
          value={String(summary?.totalJourneys ?? 0)}
          target={null}
          met={null}
          striped
        />

        <Text style={{ fontSize: 8, color: '#94a3b8', marginTop: 20 }}>{printedBy}</Text>
      </Page>
    </Document>
  )
}

export default PTSPerformancePDF
